module.exports = __webpack_public_path__ + "img/boyuan_72.65fd1838.png";